export default __webpack_public_path__ + "static/media/blissworld-clone.0801216d.png";